export const SLIDE_PANEL_CLOSE_DEEPLINK = 'slidepanel://close';

export const closeSlidePanel = (): void => {
    window.location.href = SLIDE_PANEL_CLOSE_DEEPLINK;
};
